import { Trophy, GraduationCap } from "lucide-react";

const AWARDS = [
  { y: "2024", t: "40 Under 40 Award Recipient", o: "Business Elite Awards, Australia" },
  { y: "2022 & 2023", t: "National Finalist · Influential Woman", o: "Australian Women's Small Business Champion Awards" },
  { y: "2023", t: "\u201C30 Women in EdTech Leaders to Watch\u201D", o: "EduGrowth" },
];

export default function MeetShamima() {
  return (
    <section data-testid="meet-shamima" className="relative py-20 md:py-28 bg-gradient-to-br from-[#29324A] via-[#1B1430] to-[#29324A] text-white overflow-hidden">
      <span aria-hidden className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#29324A] via-[#C43A89] to-[#C43A89]" />
      <span aria-hidden className="absolute -top-40 -right-40 w-[30rem] h-[30rem] rounded-full bg-[#C43A89]/20 blur-3xl pointer-events-none" />
      <span aria-hidden className="absolute -bottom-40 -left-40 w-[26rem] h-[26rem] rounded-full bg-[#29324A]/40 blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* Portrait */}
          <div className="lg:col-span-5">
            <div className="relative">
              <span aria-hidden className="absolute -top-3 -left-3 w-full h-full border border-[#C43A89]/40" />
              <div className="relative aspect-[3/4] bg-[#1B1430] overflow-hidden">
                <img
                  src="/assets/shamima-hero-books.png"
                  alt="Shamima Yasmin Anwar — Registered Migration Agent (MARN 2619415 · IAA Licence No. 202603837)"
                  className="w-full h-full object-cover object-center"
                />
                <span aria-hidden className="absolute bottom-0 left-0 right-0 h-1.5 bg-gradient-to-r from-[#C43A89] to-[#C43A89]" />
              </div>
              {/* Floating credentials card */}
              <div className="absolute -bottom-5 -right-3 md:-right-5 bg-white p-5 shadow-[0_20px_60px_-15px_rgba(0,0,0,0.5)] w-64 md:w-72">
                <div className="font-display text-base text-[#29324A] leading-tight">MARN 2619415 · MIA 49946 · IAA 202603837</div>
                <div className="text-[11px] text-slate-500 mt-1">Bound by the MARA Code of Conduct</div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="lg:col-span-7">
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05] mt-4">
              Meet <span className="text-[#F8B5D6]">Shamima Yasmin Anwar</span>
            </h2>
            <p className="mt-4 text-[15px] text-slate-300 leading-relaxed max-w-2xl">
              Director of StudyNet Pty Ltd — an education and migration consulting company — with over 13 years of leadership experience in the international education and migration consulting industry. Guided by ethical practice, lived experience and a deep commitment to every client&apos;s success.
            </p>

            {/* Awards — medal timeline */}
            <div className="mt-8" data-testid="shamima-highlight-0">
              <div className="flex items-center gap-2 text-[10px] font-bold tracking-[0.22em] text-[#C43A89] uppercase">
                <Trophy className="h-3.5 w-3.5" /> Awards &amp; National Recognition
              </div>
              <div className="mt-4 space-y-3">
                {AWARDS.map((a) => (
                  <div key={a.t} className="flex items-center gap-4 bg-white/[0.07] border border-white/15 backdrop-blur-sm px-4 py-3.5 hover:bg-white/[0.12] hover:border-[#C43A89]/50 transition-colors">
                    <span className="shrink-0 font-display text-[13px] text-white bg-[#C43A89] px-2.5 py-1 whitespace-nowrap">{a.y}</span>
                    <div>
                      <div className="font-display text-[15px] leading-snug">{a.t}</div>
                      <div className="text-[11.5px] text-slate-300 mt-0.5">{a.o}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Legal studies */}
            <div className="bg-white/[0.07] border border-white/15 backdrop-blur-sm p-5 mt-6" data-testid="shamima-highlight-3">
              <div className="flex items-center gap-2 text-[10px] font-bold tracking-[0.22em] text-[#C43A89] uppercase">
                <GraduationCap className="h-3.5 w-3.5" /> Legal Studies
              </div>
              <div className="font-display text-[16px] mt-2 leading-snug">Juris Doctor (JD) Candidate · RMIT University</div>
              <p className="text-[12px] text-slate-300 mt-2 leading-relaxed">With a legal studies foundation from Griffith University, currently pursuing a Juris Doctor (JD) at RMIT University as a Commonwealth Supported Place (CSP) recipient.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
